import type { Transition } from 'framer-motion';

export const POPOVER_EASE: [number, number, number, number] = [0.4, 0, 0.2, 1];

export const POPOVER_ENTER_DURATION_S = 0.22;
export const POPOVER_ENTER_OPACITY_DURATION_S = 0.16;
export const POPOVER_EXIT_DURATION_S = 0.16;
export const POPOVER_HEIGHT_LAYOUT_DURATION_S = 0.28;

export const POPOVER_HIDDEN_SCALE = 0.92;
export const POPOVER_EXIT_SCALE = 0.96;

export const DEFAULT_GAP_PX = 8;
export const DEFAULT_EDGE_MARGIN_PX = 12;
export const MOBILE_EDGE_MARGIN_PX = 6;
export const DEFAULT_ESTIMATED_HEIGHT_PX = 320;
export const DEFAULT_MAX_WIDTH_PX = 480;
export const DEFAULT_BACKDROP_OPACITY = 0.2;
export const DEFAULT_BACKDROP_BLUR_PX = 4;
export const DEFAULT_RADIUS_PX = 16;
export const POPOVER_BACKDROP_ANIMATION_MS = 180;

export const POPOVER_PLACEMENT = {
  Auto: 'auto',
  Above: 'above',
  Below: 'below',
} as const;

export const POPOVER_ALIGN = {
  Start: 'start',
  Center: 'center',
  End: 'end',
} as const;

export const POPOVER_MOTION_STATE = {
  Hidden: 'hidden',
  Visible: 'visible',
  Exit: 'exit',
} as const;

export const CONTENT_MAX_HEIGHT_INHERIT = 'inherit';

export const POPOVER_HEIGHT_WRAPPER_TRANSITION: Transition = {
  layout: {
    duration: POPOVER_HEIGHT_LAYOUT_DURATION_S,
    ease: POPOVER_EASE,
  },
};
